import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import type { LinkProps } from '@wix/editor-elements-definitions';

import type {
  TextOnPathDefinition,
  TextOnPathProps,
} from '../TextOnPath.types';
import { TranslationKeys } from './constants';

export const props = withCompInfo<TextOnPathProps, TextOnPathDefinition>()(
  ['compId', 'compData', 'translate', 'experiments'],
  ({ compData, compId, translate, experiments }) => {
    const shouldResolveLinksInPlace = Boolean(
      experiments['specs.thunderbolt.resolveLinksInPlace'],
    );

    return {
      ...compData,
      id: compId,
      translations: {
        pauseLabel: translate(
          TranslationKeys.namespace,
          TranslationKeys.pauseLabel,
        ),
        playLabel: translate(
          TranslationKeys.namespace,
          TranslationKeys.playLabel,
        ),
      },
      link: shouldResolveLinksInPlace
        ? compData.link
        : (compData.link?.resolvedLink as unknown as LinkProps),
    };
  },
);

export default createComponentMapperModel({
  props,
});
